import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  transition: box-shadow 0.2s ease-out;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { mixin } from '../helpers/mixins';
import { borderRadius } from '../style/border-radius';
export var borderShadowMixin = css(_templateObject(), function (_ref) {
  var borderColor = _ref.borderColor,
      $borderColor = _ref.$borderColor;
  return (borderColor || $borderColor) && "box-shadow: 0 0 0 1px " + (borderColor || $borderColor) + ";";
});
export var borderShadowKeys = ['borderColor'];
export var borderRadiusMixin = mixin(borderRadius, ['borderRadius', 'br']);
export var borderRadiusKeys = ['borderRadius', 'br'];